var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SDK_VERSION } from '../version';
import Axios from 'axios';
var GraphqlClient = /** @class */ (function () {
    function GraphqlClient(endpoint, options) {
        this.endpoint = endpoint;
        this.options = options;
        this.axios = Axios.create({
            withCredentials: true
        });
    }
    GraphqlClient.prototype.request = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var query, token, variables, headers, data, errors, responseData, error_1, errmsg_1, errcode_1, data_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        query = options.query, token = options.token, variables = options.variables;
                        headers = {
                            'content-type': 'application/json',
                            'x-authing-sdk-version': "js:" + SDK_VERSION,
                            'x-authing-userpool-id': this.options.userPoolId || '',
                            'x-authing-request-from': this.options.requestFrom || 'sdk',
                            'x-authing-app-id': this.options.appId || ''
                        };
                        token && (headers.Authorization = "Bearer " + token);
                        data = null;
                        errors = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axios({
                                url: this.endpoint,
                                data: {
                                    query: query,
                                    variables: variables
                                },
                                method: 'post',
                                headers: headers,
                                timeout: this.options.timeout
                            })];
                    case 2:
                        responseData = (_a.sent()).data;
                        data = responseData.data;
                        errors = responseData.errors;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.log(error_1);
                        this.options.onError(500, '网络请求错误', null);
                        throw { code: 500, message: '网络请求错误', data: null };
                    case 4:
                        if ((errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
                            errmsg_1 = null;
                            errcode_1 = null;
                            data_1 = null;
                            errors.map(function (err) {
                                var msg = err.message;
                                var code = msg.code, message = msg.message, _data = msg.data;
                                errcode_1 = code;
                                errmsg_1 = message;
                                data_1 = _data;
                                _this.options.onError(code, message, data_1);
                            });
                            throw { code: errcode_1, message: errmsg_1, data: data_1 };
                        }
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return GraphqlClient;
}());
export { GraphqlClient };
//# sourceMappingURL=data:application/json;base64,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